import { format } from 'date-fns';
import { da, enGB, nb, nl, sv } from 'date-fns/locale';

export const localeToDateFnsLocale = (locale) => {
  if (locale === 'no') {
    return nb;
  }
  else if (locale === 'sv') {
    return sv;
  }
  else if (locale === 'da') {
    return da;
  }
  else if (locale === 'nl') {
    return nl;
  }
  return enGB;
}

export const formatDate = (date, locale) => {
  const currentFnsLocale = localeToDateFnsLocale(locale);
  let displayFormat = currentFnsLocale.formatLong.date({ width: 'short' });
  // Override: DK/SV site are currenly using dd-MM-Y as format, we want to keep that format
  if (locale === 'da' || locale === 'sv') {
    displayFormat = 'dd-MM-y';
  }
  return format(date, displayFormat, { locale: currentFnsLocale });
}
